import RightSidePanel from "../../Components/RightSidePanel";
import SidePanel from "../../Components/SidePanel";
import TopBar from "../../Components/TopBar";
import Styles from "./Notification.module.css";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Package_List } from "../../Action/PacakgeAction";
import Loading from "../../Components/Loading";
import Enroll from "../Home/Enroll";
import { TAKE_A_TEST_RESET } from "../../Constant/TLatConstant";
import { Test_Result } from "../../Action/QuestionTestAction";
import { ListOrders } from "../../Action/OrderPackageAction";
// import { GET_TIME_ZONE } from "../../Model/HomeModel";
import ReactHelmet from "../../Components/ReactHelmet";
import MobileNotification from "./MobileNotification";
export default function Notification() {
  const [Score, setScore] = useState("");
  const [SidebarOpen, SetSideBarOpen] = useState(false);
  const [SidebarOpen2, setSideBarOpen2] = useState(false);
  const [OpenMenuBar2, setOpenMenuBar2] = useState(false);
  const Navigate = useNavigate();
  const Mobile_Screen = window.innerWidth;
  const { Login_User } = useSelector((state) => state.USER_LOGIN_REDUCER);
  const { loading, Test_Dets, error } = useSelector(
    (s) => s.Take_Test_Det_Reducer
  );
  const [isBuyPackage, setisBuyPackage] = useState(false);
  const [CourseId, setCourseId] = useState("");
  const [EnrollActive, setEnrollActive] = useState(false);
  const { loading: loadingPack, PackageRec } = useSelector(
    (s) => s.Package_List_Reducer
  );

  const { OrdersRec } = useSelector((s) => s.ListOrdersReducer);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(ListOrders());
  }, [dispatch]);

  const get_Packages = useCallback(() => {
    dispatch(Package_List({ page_size: 10, page_no: 1 }, "MainPackages"));
  }, [dispatch]);

  useEffect(() => {
    get_Packages();
  }, [get_Packages]);

  useEffect(() => {
    if (OrdersRec) {
      for (let i = 0; i < OrdersRec?.length; i++) {
        if (OrdersRec[i]?.isPaid) {
          setisBuyPackage(true);
          break;
        }
      }
    }
  }, [OrdersRec]);

  useMemo(() => {
    dispatch(Test_Result());
    const PsychometricTestScore = localStorage.getItem("PsychometricTestScore");
    if (PsychometricTestScore) {
      setScore(PsychometricTestScore);
    }
  }, [dispatch]);

  useEffect(() => {
    if (Test_Dets) {
      Navigate(`/T-LAT-acknowledge/${Test_Dets}`);
      dispatch({ type: TAKE_A_TEST_RESET });
    }

    if (error) {
      Navigate("/error", { state: { error } });
    }
  }, [Test_Dets, dispatch, error]);

  return Mobile_Screen <= 880 ? (
    <MobileNotification />
  ) : (
    <div className={Styles.Dashboard}>
      <ReactHelmet
        title={"Notification"}
        description={"Student Dashboard Notification"}
      />
      {/* SidePanel */}
      {Mobile_Screen >= 780 ? (
        <SidePanel
          SetSideBarOpen={SetSideBarOpen}
          SidebarOpen={SidebarOpen}
          Page="Notification"
        />
      ) : (
        ""
      )}

      {Mobile_Screen <= 480 && SidebarOpen ? (
        <SidePanel
          SetSideBarOpen={SetSideBarOpen}
          SidebarOpen={SidebarOpen}
          Page="Notification"
        />
      ) : (
        ""
      )}

      {loadingPack || loading ? <Loading /> : ""}

      {EnrollActive ? (
        <Enroll
          setEnrollActive={setEnrollActive}
          Package_Id={EnrollActive}
          courseId={CourseId}
        />
      ) : (
        ""
      )}

      {/* Middle Section */}

      {/* Middle Section */}

      <section className={Styles.MiddleSection}>
        <div>
          <TopBar
            SetSideBarOpen={SetSideBarOpen}
            SidebarOpen={SidebarOpen}
            SetSideBarOpen2={setOpenMenuBar2}
            SidebarOpen2={OpenMenuBar2}
            PageName={"Notification"}
          />
        </div>
        <div className={Styles.OnlineClassTopSection}>
          {/* <div className={Styles.Notify}>
              <div className={Styles.notification}>
                🚀 Your dashboard has been activated.
              </div>
            </div> */}
          <div className={Styles.no_notification_box}>
            <img
              src="/assets/image/No-Notification.png"
              alt="No Notification Icon"
            />
            <div className={Styles.no_notification_text}>
              You have no notifications right now.
            </div>
          </div>
        </div>
      </section>

      {/* Middle Section */}

      <RightSidePanel
        SetSideBarOpen={setOpenMenuBar2}
        SidebarOpen={OpenMenuBar2}
      />

      <div
        onClick={() => {
          SetSideBarOpen(false);
          setOpenMenuBar2(false);
        }}
        className={SidebarOpen || OpenMenuBar2 ? "overlay active" : "overlay"}
        id="overlay"
      ></div>
      {/* Right Section  */}
    </div>
  );
}
